import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import deTranslations from './locales/de.json';
import enTranslations from './locales/en.json';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            de: {
                translation: deTranslations
            },
            en: {
                translation: enTranslations
            }
        },
        supportedLngs: ['de', 'en'],
        fallbackLng: 'de',
        load: 'languageOnly',
        nonExplicitSupportedLngs: true,
        debug: false,
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
